import { PermissionT } from "../types";

export const salesDashboardView = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "sales_dashboard_view");
  return !!p;
};

export default salesDashboardView;
